import baseRequest from '../baseRequest';
import AppConfig from '../../app/config/AppConfig';

class RequestAccessToken extends baseRequest
{
    constructor(updateState, handleFailure) {
        super();
        this.name = 'RequestAccessToken';
        this.dispatch = null;
        this.response = null;
        this.config = new AppConfig();
        this.updateState = updateState;
        this.handleFailure = handleFailure;
    }

    execute(dispatch) {
        this.dispatch = dispatch;
        this.call(this.config.api.requests.requestAccessToken);
    }

    onSuccess() {
        this.updateState(this.response.data);
    }

    onFailure(response, methodName = '') {
        super.onFailure(response, methodName);
        this.handleFailure();
    }

    handleServerError(error) {
        super.handleServerError(error);
        this.handleFailure();
    }
}

export default RequestAccessToken;
